import { call, put, takeLatest } from "redux-saga/effects"

import { apiGeneratorBase } from "../../Utils/saga"
import Creators, { HealthTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getHealthMainInfoActions: {
    request: Creators.getHealthMainInfoRequest,
    success: Creators.getHealthMainInfoSuccess,
    errors: Creators.getHealthMainInfoFailure
  },
  getHealthOverviewActions: {
    request: Creators.getHealthOverviewRequest,
    success: Creators.getHealthOverviewSuccess,
    errors: Creators.getHealthOverviewFailure
  },
  getPreventionRateActions: {
    request: Creators.getPreventionRateRequest,
    success: Creators.getPreventionRateSuccess,
    errors: Creators.getPreventionRateFailure
  },
  getDataByCardTypeActions: {
    request: Creators.getDataByCardTypeRequest,
    success: Creators.getDataByCardTypeSuccess,
    errors: Creators.getDataByCardTypeFailure
  },
  getDataByCountryActions: {
    request: Creators.getDataByCountryRequest,
    success: Creators.getDataByCountrySuccess,
    errors: Creators.getDataByCountryFailure
  },
  getDataByReasonCodeActions: {
    request: Creators.getDataByReasonCodeRequest,
    success: Creators.getDataByReasonCodeSuccess,
    errors: Creators.getDataByReasonCodeFailure
  },
  getDataOlympicsActions: {
    request: Creators.getDataOlympicsRequest,
    success: Creators.getDataOlympicsSuccess,
    errors: Creators.getDataOlympicsFailure
  },
  getRiskLevelActions: {
    request: Creators.getRiskLevelRequest,
    success: Creators.getRiskLevelSuccess,
    errors: Creators.getRiskLevelFailure
  },
  getFilterOptionsActions: {
    request: Creators.getFilterOptionsRequest,
    success: Creators.getFilterOptionsSuccess,
    errors: Creators.getFilterOptionsFailure
  },
  getVampMainChartActions: {
    request: Creators.getVampMainChartRequest,
    success: Creators.getVampMainChartSuccess,
    errors: Creators.getVampMainChartFailure
  },
  getVampMonitoringProgramChartActions: {
    request: Creators.getVampMonitoringProgramChartRequest,
    success: Creators.getVampMonitoringProgramChartSuccess,
    errors: Creators.getVampMonitoringProgramChartFailure
  },
  getVampEstimatedProgramStatusActions: {
    request: Creators.getVampEstimatedProgramStatusRequest,
    success: Creators.getVampEstimatedProgramStatusSuccess,
    errors: Creators.getVampEstimatedProgramStatusFailure
  },
  getVampDescriptorsActions: {
    request: Creators.getVampDescriptorsRequest,
    success: Creators.getVampDescriptorsSuccess,
    errors: Creators.getVampDescriptorsFailure
  },
  getMcMainChartActions: {
    request: Creators.getMcMainChartRequest,
    success: Creators.getMcMainChartSuccess,
    errors: Creators.getMcMainChartFailure
  },
  getMcMonitoringProgramChartActions: {
    request: Creators.getMcMonitoringProgramChartRequest,
    success: Creators.getMcMonitoringProgramChartSuccess,
    errors: Creators.getMcMonitoringProgramChartFailure
  },
  getEfmMonitoringProgramChartActions: {
    request: Creators.getEfmMonitoringProgramChartRequest,
    success: Creators.getEfmMonitoringProgramChartSuccess,
    errors: Creators.getEfmMonitoringProgramChartFailure
  },
  getMcEstimatedProgramStatusActions: {
    request: Creators.getMcEstimatedProgramStatusRequest,
    success: Creators.getMcEstimatedProgramStatusSuccess,
    errors: Creators.getMcEstimatedProgramStatusFailure
  }
}

const eventsOptions = {
  [constants.GET_HEALTH_MAIN_INFO_REQUEST]: {
    api: services.getHealthMainInfo,
    actions: actions.getHealthMainInfoActions
  },
  [constants.GET_PREVENTION_RATE_REQUEST]: {
    api: services.getPreventionRate,
    actions: actions.getPreventionRateActions
  },
  [constants.GET_DATA_BY_CARD_TYPE_REQUEST]: {
    api: services.getDataByCardType,
    actions: actions.getDataByCardTypeActions
  },
  [constants.GET_DATA_BY_COUNTRY_REQUEST]: {
    api: services.getDataByCountry,
    actions: actions.getDataByCountryActions
  },
  [constants.GET_DATA_BY_REASON_CODE_REQUEST]: {
    api: services.getDataByReasonCode,
    actions: actions.getDataByReasonCodeActions
  },
  [constants.GET_DATA_OLYMPICS_REQUEST]: {
    api: services.getDataOlympics,
    actions: actions.getDataOlympicsActions
  },
  [constants.GET_HEALTH_OVERVIEW_REQUEST]: {
    api: services.getHealthOverview,
    actions: actions.getHealthOverviewActions
  },
  [constants.GET_RISK_LEVEL_REQUEST]: {
    api: services.getRiskLevel,
    actions: actions.getRiskLevelActions
  },
  [constants.GET_FILTER_OPTIONS_REQUEST]: {
    api: services.getFilterOptions,
    actions: actions.getFilterOptionsActions
  },
  [constants.GET_VAMP_MAIN_CHART_REQUEST]: {
    api: services.getVampMainChart,
    actions: actions.getVampMainChartActions
  },
  [constants.GET_VAMP_MONITORING_PROGRAM_CHART_REQUEST]: {
    api: services.getVampMonitoringProgramChart,
    actions: actions.getVampMonitoringProgramChartActions
  },
  [constants.GET_VAMP_ESTIMATED_PROGRAM_STATUS_REQUEST]: {
    api: services.getVampEstimatedProgramStatus,
    actions: actions.getVampEstimatedProgramStatusActions
  },
  [constants.GET_VAMP_DESCRIPTORS_REQUEST]: {
    api: services.getVampDescriptorsList,
    actions: actions.getVampDescriptorsActions
  },
  [constants.GET_MC_MAIN_CHART_REQUEST]: {
    api: services.getMcMainChart,
    actions: actions.getMcMainChartActions
  },
  [constants.GET_MC_MONITORING_PROGRAM_CHART_REQUEST]: {
    api: services.getMcMonitoringProgramChart,
    actions: actions.getMcMonitoringProgramChartActions
  },
  [constants.GET_EFM_MONITORING_PROGRAM_CHART_REQUEST]: {
    api: services.getEfmMonitoringProgramChart,
    actions: actions.getEfmMonitoringProgramChartActions
  },
  [constants.GET_MC_ESTIMATED_PROGRAM_STATUS_REQUEST]: {
    api: services.getMcEstimatedProgramStatus,
    actions: actions.getMcEstimatedProgramStatusActions
  }
}

function* monitoringInitSaga(action) {
  try {
    const payload = action.payload || {}
    const descriptorsListRes = yield call(services.getVampDescriptorsList, {
      business_account: payload.business_account
    })
    const enrollmentDataRes = yield call(services.getVampEnrollmentData, {
      business_account: payload.business_account
    })
    if (!enrollmentDataRes.ok || !enrollmentDataRes.data) {
      yield put(
        Creators.monitoringInitFailure({
          message: "Failed to fetch enrollment data"
        })
      )
      return
    }
    if (!descriptorsListRes.ok || !descriptorsListRes.data) {
      yield put(
        Creators.monitoringInitFailure({
          message: "Failed to fetch descriptors list"
        })
      )
      return
    }
    yield put(
      Creators.monitoringInitSuccess({
        descriptorsList: descriptorsListRes.data,
        enrollmentData: enrollmentDataRes.data,
        business_account: payload.business_account
      })
    )
  } catch (e) {
    yield put(
      Creators.monitoringInitFailure({
        message: "Monitoring initialization failed"
      })
    )
  }
}

function* createVampEnrollmentSaga(action) {
  const { onSuccess, onError, ...payload } = action.payload || {}
  try {
    const response = yield call(services.createVampEnrollmentRequest, payload)
    if (response.ok) {
      yield put(Creators.createVampEnrollmentSuccess({ enrollmentData: response.data }))
      if (onSuccess) onSuccess(response.data)
      yield put(Creators.monitoringInit({ business_account: payload?.business_account }))
    } else {
      const message = "Failed to create VAMP enrollment"
      yield put(Creators.createVampEnrollmentFailure())
      if (onError) onError({ message })
    }
  } catch (e) {
    const message = "VAMP enrollment request failed"
    yield put(Creators.createVampEnrollmentFailure())
    if (onError) onError({ message })
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_HEALTH_MAIN_INFO_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_HEALTH_MAIN_INFO_REQUEST])
  )
  yield takeLatest(constants.GET_PREVENTION_RATE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_PREVENTION_RATE_REQUEST])
  )
  yield takeLatest(constants.GET_DATA_BY_CARD_TYPE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_DATA_BY_CARD_TYPE_REQUEST])
  )
  yield takeLatest(constants.GET_DATA_BY_COUNTRY_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_DATA_BY_COUNTRY_REQUEST])
  )
  yield takeLatest(constants.GET_DATA_BY_REASON_CODE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_DATA_BY_REASON_CODE_REQUEST])
  )
  yield takeLatest(constants.GET_DATA_OLYMPICS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_DATA_OLYMPICS_REQUEST])
  )
  yield takeLatest(constants.GET_HEALTH_OVERVIEW_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_HEALTH_OVERVIEW_REQUEST])
  )
  yield takeLatest(constants.GET_RISK_LEVEL_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_RISK_LEVEL_REQUEST])
  )
  yield takeLatest(constants.GET_FILTER_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_FILTER_OPTIONS_REQUEST])
  )
  yield takeLatest(constants.GET_VAMP_MAIN_CHART_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_VAMP_MAIN_CHART_REQUEST])
  )
  yield takeLatest(constants.GET_VAMP_MONITORING_PROGRAM_CHART_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_VAMP_MONITORING_PROGRAM_CHART_REQUEST])
  )
  yield takeLatest(constants.GET_VAMP_ESTIMATED_PROGRAM_STATUS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_VAMP_ESTIMATED_PROGRAM_STATUS_REQUEST])
  )
  yield takeLatest(constants.GET_VAMP_DESCRIPTORS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_VAMP_DESCRIPTORS_REQUEST])
  )
  yield takeLatest(constants.GET_MC_MAIN_CHART_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_MC_MAIN_CHART_REQUEST])
  )
  yield takeLatest(constants.GET_MC_MONITORING_PROGRAM_CHART_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_MC_MONITORING_PROGRAM_CHART_REQUEST])
  )
  yield takeLatest(constants.GET_EFM_MONITORING_PROGRAM_CHART_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_EFM_MONITORING_PROGRAM_CHART_REQUEST])
  )
  yield takeLatest(constants.GET_MC_ESTIMATED_PROGRAM_STATUS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_MC_ESTIMATED_PROGRAM_STATUS_REQUEST])
  )
  yield takeLatest(constants.MONITORING_INIT, monitoringInitSaga)
  yield takeLatest(constants.CREATE_VAMP_ENROLLMENT_REQUEST, createVampEnrollmentSaga)
}
